import React from 'react';
import JSZip from 'jszip';

import { InvalidFileError, MissingOrCorruptFilesError, UncompressedSizeError } from '../components/ValidationErrors';
import { getBytesfromMB } from '../../../../lib/helpers';
import { getXlsxSheetNames } from '../../../../lib/xlsxUtils';

export const validateZip = async (
    file,
    maxUncompressedSizeMb,
    requiredFilesList,
    setValidationError,
    fileType = 'csv',
) => {
    try {
        // Will check for a valid .zip archive as well as a renamed file extension
        const zip = await JSZip.loadAsync(file);
        const fileNames = Object.keys(zip.files).map((path) => path.split('/').pop());

        let totalUncompressedSize = 0;
        Object.values(zip.files).forEach((zipEntry) => {
            if (!zipEntry.dir) {
                totalUncompressedSize += zipEntry._data.uncompressedSize;
            }
        });

        const maxUncompressedSizeInBytes = getBytesfromMB(maxUncompressedSizeMb);
        if (totalUncompressedSize > maxUncompressedSizeInBytes) {
            setValidationError({ message: <UncompressedSizeError maxSize={maxUncompressedSizeMb} /> });
            return false;
        }

        const missingFiles = requiredFilesList.filter((required) => !fileNames.includes(required));
        if (missingFiles.length > 0) {
            setValidationError({
                message: <MissingOrCorruptFilesError missingFiles={missingFiles} fileType={fileType} />,
            });
            return false;
        }
        return true;
    } catch {
        setValidationError({ message: <InvalidFileError /> });
        return false;
    }
};

export const validateExcel = async (file, requiredSheetsList, setValidationError, fileType = 'excel') => {
    try {
        const sheetNames = await getXlsxSheetNames(file);

        const missingSheets = requiredSheetsList.filter(
            (required) => !sheetNames.some((name) => name.includes(required)),
        );

        if (missingSheets.length > 0) {
            setValidationError({
                message: <MissingOrCorruptFilesError missingFiles={missingSheets} fileType={fileType} />,
            });
            return false;
        }
        return true;
    } catch {
        setValidationError({ message: <InvalidFileError /> });
        return false;
    }
};

export const validateJson = async (file, setValidationError) => {
    try {
        const text = await file.text();
        const parsed = JSON.parse(text);
        if (!parsed || typeof parsed !== 'object') {
            setValidationError({ message: <InvalidFileError /> });
            return false;
        }
        return true;
    } catch {
        setValidationError({ message: <InvalidFileError /> });
        return false;
    }
};
